import { MdStorefront } from 'react-icons/md'

const data = [
  {
    id: 5,
    icon: <MdStorefront />,
    title: 'KhoAI',
    desc: 'A real-time inventory management platform that helps businesses prevent stockouts and protect revenue across warehouses and stores. khoai.io provides multi-location stock visibility, low-stock alerts, restock thresholds, transaction history, role-based access, CSV imports, and barcode-ready workflows — with a free plan and setup in under 15 minutes. Built with TypeScript, Node.js, Hono, SolidJS, MongoDB, and Redis.'
  }
]

export default data
